export async function loadWorkspace() {
  const response = await fetch('/api/workspace', { cache: 'no-store' });
  const data = await response.json().catch(() => null);
  if (!response.ok || !['platform', 'company'].includes(data?.kind) ||
      data.hostname !== window.location.hostname.toLowerCase().replace(/\.$/, '') ||
      (data.kind === 'company' && (!data.companyId || typeof data.companyName !== 'string'))) {
    throw new Error(data?.error || 'This workspace address is unavailable. Ask your HR administrator to check the address.');
  }
  // Only the same-origin logo endpoint is accepted, even if a proxy/cache supplies bad metadata.
  return { ...data, logo: data.logo === '/api/workspace-logo' ? data.logo : null };
}
export function applyWorkspaceBranding(workspace) {
  const name = workspace.kind === 'company' ? workspace.companyName : 'TrustWork';
  document.title = `${name} Payroll`;
  const meta = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (meta) meta.setAttribute('content', `${name} Employee`);
  const manifest = document.querySelector('link[rel="manifest"]');
  if (manifest) manifest.setAttribute('href', '/api/workspace-manifest');
  if (workspace.logo) {
    const icon = document.querySelector('link[rel="apple-touch-icon"]');
    if (icon) icon.setAttribute('href', workspace.logo);
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) favicon.setAttribute('href', '/api/workspace-icon.svg');
  }
}
